import $ from 'jquery';

$(function() {
	const $wrapper = $( '.js-post-items-wrapper' );

	if ( $wrapper && $wrapper.length ) {
		const loading = window.daily2019Data.loading;

		$wrapper
		.on( 'click', '.js-load-more', function( event ) {
			event.preventDefault();
	
			const $postsWrapper = $( '.js-post-items' );
			const $button = $( this );
	
			$button.attr( 'disabled', true );
	
			let doingAjax = false;
	
			if ( ! doingAjax ) {
				$.ajax( {
					url: $button.attr( 'href' ),
					method: 'get',
					data: {
						'daily-2019-ajax': 'true',
					},
					beforeSend: function() {
						doingAjax = true;
						$button.text( loading );
					},
					success: function( data ) {
						const $container = $( $.parseHTML( data ) );
						const $posts = $container.find( '.js-post-item' );

						if ( $posts.length ) {
							$postsWrapper.append( $posts );
	
							const $newButton = $container.find( '.js-load-more' );
		
							if ( $newButton.length ) {
								$button.before( $newButton );
							}
						}

						$button.remove();
						doingAjax = false;
					},
					error: function() {
						$button.remove();
						doingAjax = false;
					}
				} );
			}
		} );
	}
} );
